import type { DocumentWithTimestamps, Timestamp } from './firebase.ts'
import type { UserId } from './ids.ts'
import type { SkillId } from './Skill.ts'

export enum MembershipRequestStatus {
    REQUESTED = 'requested',
    ACCEPTED = 'accepted',
    REJECTED = 'rejected'
}

export enum ExperienceLevel {
    main = 'main',
    marginal = 'marginal',
    interested = 'interested'
}

export enum BehaviorInNewGroup {
    progress = 'progress',
    initiate = 'initiate',
    passive = 'passive',
    involve = 'involve'
}

export enum SeniorityLevel {
    expert = 'expert',
    marginal = 'marginal',
    noExperience = 'noExperience'
}

export enum ReferralSource {
    knownPerson = 'knownPerson',
    socialMedia = 'socialMedia',
    newsletter = 'newsletter',
    website = 'website',
    other = 'other'
}

export type MembershipRequestFormData = {
    skillId: SkillId
    userId?: UserId
    firstName: string
    lastName: string
    email: string
    phone: string
    workPosition: string
    workOrg: string
    experienceLevel: ExperienceLevel
    behaviorInNewGroup?: BehaviorInNewGroup
    seniorityLevel: SeniorityLevel
    problemsMotivation?: string
    joinMotivation: string
    referralSource?: ReferralSource
    referralSourceOther?: string
    targetsMotivation?: string
    referenceProject?: string
    message: string
    status: MembershipRequestStatus
    acceptedAt?: Timestamp
    rejectedAt?: Timestamp
}

export type MembershipRequestId = string

export type MembershipRequest = DocumentWithTimestamps &
    MembershipRequestFormData & {
        id: MembershipRequestId
    }
